import React from 'react';

const Hamburger = ({ onClick, formattedCartItems, threadsUnread }) => {
    const notificationCount = formattedCartItems + threadsUnread;
    return (
        <button
            aria-label="Meny"
            className="slim-header__menu-link unbutton px-3"
            onClick={onClick}>
            {notificationCount > 0 ? (
                <span className="slim-header__notification">
                    {notificationCount}
                </span>
            ) : null}
            <span
                className="slim-header__nav-icon hamburger-icon"
                aria-hidden="true">
                <i />
            </span>
        </button>
    );
};

export default Hamburger;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/hamburger.jsx